import { render, staticRenderFns } from "./Assets.vue?vue&type=template&id=36e5a4fd&"
import script from "./Assets.vue?vue&type=script&lang=ts&"
export * from "./Assets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports